import React, { useEffect, useRef, useState } from 'react';

const DebugImage = ({ src, alt, ...props }) => {
  const imgRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    
    const checkImage = async () => {
      try {
        const response = await fetch(src);
        if (!response.ok) throw new Error('Network response was not ok');
        
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const img = new Image();
        
        img.onload = () => {
          if (imgRef.current) {
            imgRef.current.src = blobUrl;
          }
          setLoading(false);
        };
        
        img.onerror = () => {
          setLoading(false);
          URL.revokeObjectURL(blobUrl);
        };
        
        img.src = blobUrl;
      } catch (error) {
        console.error('Image check failed:', error);
        setLoading(false);
      }
    };

    checkImage();
  }, [src]);

  return (
    <div style={{ position: 'relative', ...props.style }}>
      <img
        ref={imgRef}
        alt={alt}
        style={{
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.3s ease',
        }}
        {...props}
      />
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f0f0f0'
        }}>
          Načítání...
        </div>
      )}
    </div>
  );
};

export default DebugImage;